import styled from "styled-components"

import { ElementProps, elementCss } from "legacy/components/shared/base"

export type GridProps = ElementProps

const Grid = styled.div<GridProps>`
  ${elementCss}
`

Grid.defaultProps = {
  display: "grid",
  gridGap: "0 3%",
  gridTemplateRows: "auto",
  margin: "0 auto",
  maxWidth: "contentWidth",
}

export default Grid
